module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('md-app', [_c('md-app-drawer', {
    attrs: {
      "md-permanent": "clipped"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/MM-lock-up@3x.png")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Mamamia Management System")])])]), _vm._v(" "), _c('md-list', [_c('md-divider'), _vm._v(" "), (_vm.permissionLookup('articlesSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Articles")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('create-article', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'create-article' ? 'active-item' : 'z',
    on: {
      "click": function($event) {
        _vm.currentTab = 'create-article'
      }
    }
  }, [_c('md-icon', [_vm._v("note_add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Article")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Create Article")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('articleList', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'articleList' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'articleList'
      }
    }
  }, [_c('md-icon', [_vm._v("list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Articles")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Articles")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('articlesSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('verticalsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Verticals")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('widgets', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'widgets' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'widgets'
      }
    }
  }, [_c('md-icon', [_vm._v("view_agenda")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Widgets")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Widgets")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('seo', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'seo' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'seo'
      }
    }
  }, [_c('md-icon', [_vm._v("pageview")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("SEO")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('categories', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'categories' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'categories'
      }
    }
  }, [_c('md-icon', [_vm._v("category")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Manage")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Manage Categories")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('verticalsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videosSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Videos")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videos', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'videos' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'videos'
      }
    }
  }, [_c('md-icon', [_vm._v("video_library")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Playlists")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Video Playlists")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('videosSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcastsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Podcasts")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcasts', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'podcasts' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'podcasts'
      }
    }
  }, [_c('md-icon', [_vm._v("playlist_add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Add Podcast")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Add Podcast")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcasts', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'podcasts' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'podcasts'
      }
    }
  }, [_c('md-icon', [_vm._v("playlist_play")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Podcasts")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Podcasts")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('podcastsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitionsSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Branded")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('branded', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'branded' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'branded'
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("AJAX Tracker")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("AJAX Tracker")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitions', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'competitions' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'competitions'
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Competition")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Create Competition")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitions', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'competitions' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'competitions'
      }
    }
  }, [_c('md-icon', [_vm._v("view_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("List Competitions")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("List Competitions")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('competitionsSection', _vm.permission)) ? _c('md-divider') : _vm._e(), _vm._v(" "), (_vm.permissionLookup('adminSection', _vm.permission)) ? _c('md-subheader', [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('tags', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'tags' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'tags'
      }
    }
  }, [_c('md-icon', [_vm._v("label")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Tag Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('users', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'users' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'users'
      }
    }
  }, [_c('md-icon', [_vm._v("supervisor_account")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Users")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("User Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('authors', _vm.permission)) ? _c('md-list-item', {
    class: _vm.currentTab === 'authors' ? 'active-item' : '',
    on: {
      "click": function($event) {
        _vm.currentTab = 'authors'
      }
    }
  }, [_c('md-icon', [_vm._v("person_outline")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Authors")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("Author Management")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissionLookup('adminSection', _vm.permission)) ? _c('md-divider') : _vm._e()], 1)], 1), _vm._v(" "), _c('md-app-content', [_c(_vm.currentTab, {
    tag: "component"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40dd62b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 655
// module chunks = 1